enum WidgetLegendIcon {
  Square = 'square',
  TriangleRight = 'triangle-right',
  TriangleBottom = 'triangle-bottom'
}

export default WidgetLegendIcon;
